import ad from '@/api/stock/adjustment'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  products: [],
  users: [],
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
}

export const getters = {
  // getProduct: state => ({ chosenProduct, productCurrentRow } = {}) => {
  //   if(chosenProduct !== undefined && productCurrentRow !== undefined){
  //     return state.products.filter(p => 
  //       !_.includes(chosenProduct.filter(cp => cp.product_id != productCurrentRow).map(el => el.product_id),p.product_id)
  //     );
  //   }
  //   return state.products;
  // },
  getUom: state => productId => {
    let prod =  state.products.find(p => p.product_id == productId)
    return prod.uom_category.unit_of_measures.find(u => u.is_default == true);
  },
  isDefaultUom: state => productId => {
    if(productId){
      let product = state.products.find(p => p.product_id == productId)
      var uom = product.uom_category.unit_of_measures.find(u => u.is_default == true)
      return uom.uom_id
    }
    return null
  },
}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  },
  SET_PRODUCT(state, data){
    let checkExist = state.products.find(p => p.product_id == data.product_id)
    if(!checkExist){
      state.products.push(data)
    }
  },
  SET_USER(state, data){
    state.users = data
  },
  CLEAR_SETUP(state){
    state.products = []
    state.users = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return ad.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return ad.store(data)
  },
  update(context, { id, data }) {
    return ad.update(id, data)
  },
  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await ad.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, {id , data}){
    return ad.destroy(id, data)
  },
  getSysQty(context, attrubutes = {}){
    return ad.sysQty(attrubutes.product_id, { params: attrubutes })
  },
  async fetchResource(context){
    // let var_product = await ad.product()
    //   context.commit('SET_PRODUCT', var_product.data)
    let var_user = await ad.user()
      context.commit('SET_USER', var_user.data)
  },
  async getProduct(context, attributes = {}){
    return await ad.product({ params: attributes })
  },
}
